import React from 'react';
import { downloadFile } from '$/store/export/actions';
import { toastError } from '$/store/toast/actions';
import { connect } from 'react-redux';
import { AppState } from '$/store';
import AdminCompanyDocumentGrids from '$/components/company-documents-grid';
import { Link } from 'react-router-dom';
import * as Bixby from '$/core';
import './index.scss';
import { getIsCurrentCompanyPublicState } from '$/store/company/selectors';

interface IProps {
  currentCompany?: Bixby.Models.AdminCompany;
  isCurrentCompanyPublic: boolean;
}
const CompanyDocumentHosting: React.FC<IProps> = props => {
  const { currentCompany, isCurrentCompanyPublic } = props;

  return (
    <>
      <section className="admin-profile-section bottom">
        <h2>Bixby Document Hosting</h2>
        {isCurrentCompanyPublic ? (
          <p>Document hosting not available for public companies.</p>
        ) : (
          <>
            <p>
              Upload more documents{' '}
              {currentCompany && (
                <Link className="link" to={`/admin/company/${currentCompany.id}/document-hosting/upload`}>
                  here
                </Link>
              )}
              .
            </p>
            <AdminCompanyDocumentGrids />
          </>
        )}
      </section>
    </>
  );
};

const mapStateToProps = (state: AppState) => {
  const { isCurrentCompanyPublic } = getIsCurrentCompanyPublicState(state);
  return {
    isCurrentCompanyPublic,
    currentCompany: state.companyState.currentCompany,
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  dispatchDownloadDocument: (blob: Blob, fileName: string) => dispatch(downloadFile(blob, fileName)),
  dispatchDownloadFailure: () => dispatch(toastError('Failed to download document')),
});

export default connect(mapStateToProps, mapDispatchToProps)(CompanyDocumentHosting);
